import React, { useState } from "react";
import Layout from "Layout";
import Section from "Layout/Section";
import BundleHelp from "components/BundlePromotion/BundleHelp";
import { Box, Button, Text, Card } from "common";
import { setLocation } from "store/actions/auth.actions";
import { useDispatch } from "react-redux";
import GiftHelp from "pages/GiftHelp";

const CartBundleHelper: React.FC = () => {

  const dispatch = useDispatch();
  const [activeSection, setActiveSection] = useState("bundle");

  const helpSections = [
    { id: "bundle", title: "Bundle Campaign", component: <BundleHelp /> },
    { id: "freegift", title: "Free Free Gift Campaign", component: <GiftHelp /> },
  ];

  const onBack = () => {
    dispatch(setLocation("/cart-bundles"));
  };

  return (
    <Layout>
      <Section>
        <Card
          padding={["30px 15px", "30px"]}
          borderRadius="5px"
          boxShadow="0px 0px 16px 0px rgb(0 0 0 / 9%)"
          marginTop="15px"
        >
          <Text color="primary" fontSize={16}>
            Bundle & Free Gift Campaign Help
          </Text>
          <Box display="flex" margin="20px 0">
            {helpSections.map((section) => (
              <Button
                key={section.id}
                variant="text"
                onClick={() => setActiveSection(section.id)}
                color={activeSection === section.id ? "primary" : "default"}
                padding="8px 25px 8px 0"
                fontSize="14px"
              >
                {section.title}
              </Button>
            ))}
          </Box>
          <Box>
            {
              helpSections.find((section) => section.id === activeSection)
                ?.component
            }
          </Box>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            width="100%"
            mt={1}
          >
            <Button
              variant="outlined"
              round
              margin="15px 0"
              width="auto"
              minWidth="200px"
              onClick={onBack}
              color="primary"
            >
              Back
            </Button>
          </Box>
        </Card>
      </Section>
    </Layout>
  );
};

export default CartBundleHelper;